import { render, staticRenderFns } from "./BscProductionForecastDayYield.vue?vue&type=template&id=367f0144&scoped=true"
import script from "./BscProductionForecastDayYield.vue?vue&type=script&lang=js"
export * from "./BscProductionForecastDayYield.vue?vue&type=script&lang=js"
import style0 from "./BscProductionForecastDayYield.vue?vue&type=style&index=0&id=367f0144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367f0144",
  null
  
)

export default component.exports